import { SerializableObject } from '../../common-react/core';

import { CustomsInstructionsForHandling } from '../other/customs-instructions-for-handling.enum';

import { ShipmentDocument } from './shipment-document.do';

/** @see mobiz-posturinn-extension:Posturinn.Extension.Models.DTO.CustomsInformation */
export class CustomsInformation extends SerializableObject {
  public additionalInformation?: string;
  public instructionsForHandling?: CustomsInstructionsForHandling;
  public documents?: ShipmentDocument[];
}
